import React from 'react';

const InputError = ({empty, invalidEmail, invalidPhone, name, type, visible}) => {
  return (
    <p className="field-error">
      {visible && empty
        ? 'Ce champ est requis.'
        : name === 'phone' && invalidPhone
        ? 'Vérifiez le format du numéro de téléphone'
        : type === 'email' && invalidEmail
        ? "Vérifiez le format de l'email."
        : ''}
    </p>
  );
};

export default InputError;
